import { render, staticRenderFns } from "./ControlloAlloggiControlliView.vue?vue&type=template&id=f8b41540&"
import script from "./ControlloAlloggiControlliView.vue?vue&type=script&lang=ts&"
export * from "./ControlloAlloggiControlliView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports